import React from 'react';
import { RecoilRoot } from 'recoil';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import smoothscroll from 'smoothscroll-polyfill';

import Environment from 'b2b-ui-components-lib/lib/services/environment';

import config, { ENV_NAME, ENV_NAME_ASSETS } from './config/config';
import { Base_Href, APP_NAME } from './common/constants/app.constants';
import { getRouteBasedUILog, setEnvUrls } from './common/utils/app.utils';
import * as serviceWorker from './serviceWorker';
import { initializeSentry } from './common/utils/sentry.utils';

import './index.scss';
window['APP_ENV'] = config.env;
smoothscroll.polyfill();

initializeSentry({ module: APP_NAME });
new Promise((resolve, reject) => {
  fetch(`${config.staticAssetsUrl}json/environment.${ENV_NAME_ASSETS[config.env]}.json`)
    //fetch(`${config.staticAssetsUrl}json/environment.${(process.env.REACT_APP_ENV || ENV_NAME.DEV).toLowerCase()}.json`)
    .then((res) => res.json())
    .then((data) => {
      if (config.env.toLowerCase() === ENV_NAME.QA.toLocaleLowerCase()) {
        data['dataTmoTrackOrderBasePageUrl'] = 'https://test.airtel.in/atb-integration/track-orders/';
      }
      data = setEnvUrls(data, config.env); //set test server Urls for cross teams platforms/dependencies
      Environment.setEnv(data);
      resolve();
    })
    .then(() => {
      const App = require('./App').default;
      const container = document.getElementById('root');
      const root = createRoot(container);
      root.render(
        <RecoilRoot>
          <BrowserRouter basename={Base_Href}>
            <App />
          </BrowserRouter>
        </RecoilRoot>
      );
    });
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
